import useOrganizationUsersTableData from "@/blocks/navigation/settings/hooks/useOrganizationUsersTableData";
import { OrganizationUsersSkeletonRow } from "@/blocks/navigation/settings/OrganizationUsersSkeletonRow";
import { DataTable } from "@/components/data-table/data-table";
import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { CustomColumnDef } from "@/components/data-table/types/custom-column-def";
import UserAvatar from "@/components/images/UserAvatar";
import { User } from "@/models/users/User";
import { FC } from "react";

const UsersTable: FC = () => {
  const {
    data,
    pageCount,
    pageIndex,
    pageSize,
    setPageIndex,
    setPageSize,
    sorting,
    setSorting,
    isLoading,
  } = useOrganizationUsersTableData(10);

  const getColumns = () => {
    const columns: CustomColumnDef<User>[] = [
      {
        accessorKey: "firstName",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Navn" />
        ),
        cell: ({ row }: { row: { original: User } }) => {
          const user = row.original;
          return (
            <div className="flex items-center gap-2">
              <UserAvatar user={user} avatarClassName="size-7" />
              <span>
                {user.firstName && user.lastName
                  ? user.firstName + " " + user.lastName
                  : "Bruger ikke onboardet"}
              </span>
            </div>
          );
        },
        meta: {
          displayName: "Navn",
          dataType: "text",
        },
      },
      {
        accessorKey: "email",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Email" />
        ),
        meta: {
          displayName: "Email",
          dataType: "text",
        },
      },
      {
        accessorKey: "loginCount",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Antal logins" />
        ),
        meta: {
          displayName: "Antal logins",
          dataType: "number",
        },
      },
      {
        accessorKey: "lastLogin",
        header: ({ column }) => (
          <DataTableColumnHeader column={column} title="Sidste login" />
        ),
        cell: ({ row }: { row: { original: User } }) => {
          const user = row.original;
          return (
            <div>
              {user.lastLogin
                ? new Date(user.lastLogin).toLocaleString()
                : "Aldrig"}
            </div>
          );
        },
        meta: {
          displayName: "Sidste login",
          dataType: "date",
        },
      },
    ];

    return columns;
  };
  return (
    <DataTable
      columns={getColumns()}
      data={data}
      pageCount={pageCount}
      pageIndex={pageIndex}
      pageSize={pageSize}
      setPageIndex={setPageIndex}
      setPageSize={setPageSize}
      sorting={sorting}
      setSorting={setSorting}
      hasToolbar={false}
      isLoading={isLoading}
      skeletonComponent={OrganizationUsersSkeletonRow}
      stickyHeader
      pageSizeOptions={[10, 25, 50, 75, 100]}
    />
  );
};

export default UsersTable;
